<template>
  <div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px;height: auto !important;"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Airline Details</b-navbar-brand>

          <!-- <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="sm" variant="warning" @click="goToMain">New Client</b-button>
            </b-nav-form>
          </b-navbar-nav>-->
        </b-navbar>

        <b-card>
          <b-row>
            <b-col md="3">
              <label>Digit Code</label>
              <b-form-input :formatter="capitalizeAll" id="digitCode" name="digitCode" v-model="airModal.digitCode"></b-form-input>
              <span class="error" v-if="!airModal.digitCode">{{errorList.digitCode}}</span>
            </b-col>
            <b-col md="3">
              <md-layout md-flex="100">
                <label>Airline Name</label>
                <b-form-input :formatter="capitalizeAll" id="airlineName" name="airlineName" v-model="airModal.airlineName"></b-form-input>
              </md-layout>
              <span class="error" v-if="!airModal.airlineName">{{errorList.airlineName}}</span>
            </b-col>
            <b-col md="3">
              <label>IATA Designator</label>
                <b-form-input :formatter="capitalizeAll"
                  id="iataDesignator"
                  name="iataDesignator"
                  v-model="airModal.iataDesignator"
                ></b-form-input>
            </b-col>
            <b-col md="3">
              <label>ICAO Designator</label>
              <b-form-input :formatter="capitalizeAll"
                id="icaoDesignator"
                name="icaoDesignator"
                v-model="airModal.icaoDesignator"
              ></b-form-input>
            </b-col>
          </b-row>
            <md-layout md-gutter class="mt-3">
            <md-layout class="justify-content-center">
              <b-button
                variant="primary"
                size="sm"
              class="smbutnWidth " 
                @click="addAirLine"
                id="addButtonLoader"
              >{{(airModal.airlineId!='')?'Update':"Add"}}</b-button>
              <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
            </md-layout>
          </md-layout>
        </b-card>
        <div class="mt-2">
          <h5 class="text-muted pull-right mt-2 ml-3">

            <b-button
                size="sm"
                class="ml-2"
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                @click="getData('Excel')"
                variant="outline-info"
                > {{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              
            <small>{{totalRows}} Entries</small>
          </h5>
        </div>
        <!-- User Interface controls -->
        <div class="mt-2">
          <b-form-group>
            <b-input-group>
              <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type To Search"/>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="table-responsive tableMain">
          <!-- Main table element -->
          <b-table
            show-empty
            stacked="md"
            :items="airLineArray"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template slot="airlineId" slot-scope="row0">
              <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="isAirActive" slot-scope="row1">
              <b-button variant="outline-info" @click="editAir(row1.item)">Edit</b-button>
            </template>

            <template slot="isAirStatusActive" slot-scope="row2">
              <div v-if="adminToggle == 'Admin'" :id="'row' + row2.item.airlineId">
                <md-switch
                  :id="'approval' + row2.item.airlineId"
                  name="approval"
                  class="md-primary"
                  :value="row2.item.isAirActive == 1 ? true : false"
                  @change="activateUser(row2.item)"
                >
                  <h6>
                    <br/>
                    <b-badge style="margin-left: -45px">{{
                      row2.item.isAirActive == 1 ? "Active" : "In-Active"
                    }}</b-badge>
                  </h6>
                </md-switch>
              </div>
              <div v-else :id="'row' + row2.item.airlineId">
                <h6>
                  <b-badge>{{
                    row2.item.isAirActive == 1 ? "Active" : "In-Active"
                  }}</b-badge>
                </h6>
              </div>
            </template>

          </b-table>
        </div>

        <b-row>
          <b-col md="12" class="my-1">
            <b-pagination
              limit="5"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              align="center"
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <!-- <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>-->
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/location/airModal");

      this.getData("Normal");
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      selectDateFormat,
      fields: [
        {
          key: "airlineId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "airlineName",
          label: "Airline Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "digitCode",
          label: "Digit Code",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "iataDesignator",
          label: "IATA Designator",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "icaoDesignator",
          label: "ICAO Designator",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "isAirActive",
          label: "Action",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "isAirStatusActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      commodityTypeName: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "Hazardous"
        },
        {
          commodityTypeVal: "Non_Hazardous",
          commodityTypeText: "Non Hazardous"
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "Reefer"
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "Others"
        }
      ],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      // excelUpload: "",
      airModal: {
        airlineId: "",
        digitCode: "",
        airlineName: "",
        iataDesignator: "",
        icaoDesignator: "",
      },
      CommodityError: [" Enter Digit Code", " Enter Airline Name"],
      errorList: {
        digitCode: "",
        airlineName: ""
      },

      airLineArray: [],
      validate: true,
      deleteId: "",

      indexNew: "",
      itemObj: {},
      adminToggle: this.$sessionsStorage.get("designation")
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    Loading
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function() {
        $("#portLocationNew11").DataTable();
      });
    },

    validateCommodity() {
      let validate_new = true;

      Object.keys(this.errorList).map((x, index) => {
        if (this.airModal[x] == "") {
          this.errorList[x] = this.CommodityError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addAirLine() {
      //  this.validateCommodity();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addAirline.php`,
          data: JSON.stringify(this.airModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              // window.location.reload(true);
              if (this.airModal.airlineId != "") {
                this.alert.content = "Data updated Successfully";
              } else {
                this.alert.content = "Data Added Successfully";
              }

              this.$refs["addPop"].open();
              this.getData("Normal");
              Object.keys(this.airModal).map((x, index) => {
                this.airModal[x] = "";
                this.errorList[x] = "";
              });
            }
          })
          .catch(error => {});
      }
    },

    editAir(item) {
      this.airModal.airlineId = item.airlineId;
      this.airModal.airlineName = item.airlineName;
      this.airModal.digitCode = item.digitCode;
      this.airModal.iataDesignator = item.iataDesignator;
      this.airModal.icaoDesignator = item.icaoDesignator;
    },

    getData(type) {
      let type_Size = {
        airModal: "airModal",
        Param:'List',
        type: type
      };

      if(type == "Excel"){
        this.ExcelBtnName = "Downloading....";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/fetchAirLine.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            this.airLineArray = data.airLineDetail;
            this.totalRows = data.airLineDetail.length;

            if (type == "Excel") {
              if (data.airLineDetail.length > 0) {
                this.airLineArray = data.airLineDetail;
                this.totalRows = data.airLineDetail.length;
                this.ExcelBtnName = "Export as Excel";
              }
              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.airLineDetail.length > 0) {
                this.airLineArray = data.airLineDetail;
                this.totalRows = data.airLineDetail.length;
                console.log(" Airline Master List response=>", data);
              }
            }
            // this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch(error => {});
    },

    activateUser(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.airlineId;

      this.itemObj.isAirActive = this.itemObj.isAirActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "airlinemaster",
        tableId: "airlineId",
        tableIsActive: "isAirActive",
        value1: this.itemObj.isAirActive,
        tableVal: this.deleteId,
        isMailSend:'No',
        manual:'No',
      };

      
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          console.log("Salil Result => ", result);
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getData("Normal");
          }
        })
        .catch((error) => {});

      // this.alert.content = true
      //   ? "Are you sure you want to Activate this User?"
      //   : "Are you sure you want to Deactivate this User?";
      // this.$refs["addPop6"].open();
    }
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// airlineMaster.vue?9e60ce06